
import Button from '../../../components/base/Button';

export default function FundingSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-white via-blue-50 to-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-emerald-600 to-blue-600 text-white rounded-full text-sm font-semibold mb-8 shadow-lg">
              <i className="ri-funds-line mr-2"></i>
              Investment Property Financing
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Fund Your Investment Property
            </h2>
            
            <p className="text-xl text-slate-600 mb-8 leading-relaxed">
              In the past year, we have funded two of our rental properties using DSCR loans ($2.1M Personal Properties Funded) and we have helped our friends fund theirs. We are now extending our knowledge and expertise to you whether it's your first rental, or if you're considering rental expansion.
            </p>

            {/* Key benefits */}
            <div className="space-y-4 mb-10">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-lg flex items-center justify-center mr-4 flex-shrink-0 shadow-lg">
                  <i className="ri-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-900 mb-1">No Personal Income Verification</h3>
                  <p className="text-slate-600">Qualify based on property cash flow, not personal income</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-lg flex items-center justify-center mr-4 flex-shrink-0 shadow-lg">
                  <i className="ri-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-900 mb-1">Fast Approval Process</h3>
                  <p className="text-slate-600">Streamlined process designed for real estate investors</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-lg flex items-center justify-center mr-4 flex-shrink-0 shadow-lg">
                  <i className="ri-check-line text-2xl text-white"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-slate-900 mb-1">Proven Track Record</h3>
                  <p className="text-slate-600">Successfully funded multiple investment properties</p>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                size="lg" 
                className="bg-gradient-to-r from-blue-600 to-emerald-600 hover:from-blue-700 hover:to-emerald-700 text-white font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                onClick={() => window.REACT_APP_NAVIGATE('/dscr')}
              >
                <i className="ri-arrow-right-line mr-2"></i>
                Explore More
              </Button>
              <Button 
                size="lg" 
                variant="outline"
                className="border-2 border-slate-900 text-slate-900 hover:bg-slate-900 hover:text-white font-bold shadow-lg transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                onClick={() => window.REACT_APP_NAVIGATE('/#contact')}
              >
                <i className="ri-mail-line mr-2"></i>
                Contact Us
              </Button>
              <Button 
                size="lg" 
                className="bg-slate-900 text-white hover:bg-slate-800 font-bold shadow-xl transform hover:scale-105 transition-all duration-300 whitespace-nowrap cursor-pointer"
                onClick={() => {
                  window.REACT_APP_NAVIGATE('/dscr');
                  setTimeout(() => {
                    const calculator = document.getElementById('dscr-calculator');
                    if (calculator) {
                      calculator.scrollIntoView({ behavior: 'smooth' });
                    }
                  }, 100);
                }}
              >
                <i className="ri-calculator-line mr-2"></i>
                DSCR Calculator
              </Button>
            </div>
          </div>

          {/* Right side - Visual */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/783bc7a5c823fb381aad3c282fa33e78.jpg"
                alt="Investment Property Funding"
                className="w-full h-96 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
              
              {/* Floating stats */}
              <div className="absolute bottom-8 left-8 right-8">
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                    <div className="text-3xl font-bold text-blue-600 mb-1">$2.1M</div>
                    <div className="text-sm text-slate-600 font-medium">Properties Funded</div>
                  </div>
                  <div className="bg-white/95 backdrop-blur-sm rounded-xl p-4 shadow-lg">
                    <div className="text-3xl font-bold text-emerald-600 mb-1">DSCR</div>
                    <div className="text-sm text-slate-600 font-medium">Loan Expertise</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-gradient-to-br from-blue-500 to-emerald-500 rounded-full opacity-20 blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-gradient-to-br from-emerald-500 to-blue-500 rounded-full opacity-20 blur-2xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
